export const NAME = "sellerProfiles"
export const FIREBASE_PATH = "sellerProfiles"
export const FIREBASE_REVIEWS_PATH = "reviews"
